/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCostItemRequest
 */
export interface CreateCostItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    costType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCostItemRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCostItemRequest
     */
    monthlyCost?: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateCostItemRequest
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCostItemRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCostItemRequest
     */
    sunk?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCostItemRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreateCostItemRequest interface.
 */
export function instanceOfCreateCostItemRequest(value: object): value is CreateCostItemRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCostItemRequestFromJSON(json: any): CreateCostItemRequest {
    return CreateCostItemRequestFromJSONTyped(json, false);
}

export function CreateCostItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCostItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'costType': json['costType'] == null ? undefined : json['costType'],
        'category': json['category'] == null ? undefined : json['category'],
        'status': json['status'] == null ? undefined : json['status'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'sunk': json['sunk'] == null ? undefined : json['sunk'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreateCostItemRequestToJSON(json: any): CreateCostItemRequest {
    return CreateCostItemRequestToJSONTyped(json, false);
}

export function CreateCostItemRequestToJSONTyped(value?: CreateCostItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'costType': value['costType'],
        'category': value['category'],
        'status': value['status'],
        'amount': value['amount'],
        'monthlyCost': value['monthlyCost'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'sunk': value['sunk'],
        'notes': value['notes'],
        'effectTenantId': value['effectTenantId'],
    };
}

